module.exports = __webpack_public_path__ + "front/img/p11.eea93f6e.png";